import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function SmallCardWithImage ({
  children,
  title,
  subtitle,
  image,
  text,
  onClick,
  forceColumn = false,
  className = ''
}) {
  const imageElement = image ? <div className='mx-auto mb-8 max-w-xs px-2'>{image}</div> : null
  const titleElement = title ? <div className='text-xl font-medium'>{title}</div> : null
  const subtitleElement = subtitle ? <div className='text-gray-500 mt-1'>{subtitle}</div> : null
  const textElement = text ? <div className='text-gray-500 mt-4 text-sm'>{text}</div> : null

  const _outerWrapperClassNames = classNames(
    'order-card bg-white rounded-lg px-6 py-6 flex items-center justify-between',
    { 'lg:text-center lg:flex-col': forceColumn === false },
    { 'text-center flex-col': forceColumn === true },
    className
  )

  const _outerImageClassNames = classNames(
    'relative w-full',
    'h-32 lg:h-48',
    { 'lg:mb-8 lg:pb-1/3': forceColumn === false },
    { 'mb-8 pb-1/3': forceColumn === true }
  )

  return (
    <div
      className={_outerWrapperClassNames}
      onClick={onClick}
    >
      <div className={_outerImageClassNames}>
        <div className='absolute top-0 left-0 w-full h-full flex items-center justify-center'>
          {image}
        </div>
      </div>
      <div className='w-full'>
        {titleElement}
        {subtitleElement}
        {textElement}
        {children}
      </div>
    </div>
  )
}

SmallCardWithImage.defaultProps = {
  onClick: null
}

SmallCardWithImage.propTypes = {
  /**
   * Controls the title of the box
   */
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * Controls the subtitle of the box
   */
  subtitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * Add additional text to the card (below subtitle)
   */
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object
  ]),
  /**
   * Controls the image of the box
   */
  image: PropTypes.node,
  /**
   * onClick function for the button
   */
  onClick: PropTypes.func
}

export default SmallCardWithImage
